import React from 'react'
import Footer from './Footer/Footer.js'
// import Breadcrumbs from '../Breadcrumbs/Breadcrumbs'
import SnackbarAlert from './Snackbar/Snackbar.js'
import { Outlet, useMatches } from 'react-router-dom'
import Header from './Header/Header.js'

export default function PageDefault() {
  const matches = useMatches();
  const hideFooter = matches.some(m => m.handle?.hideFooter);
  return (
    <>
    <Header/>
    <div className='wrapper'>
        {/* <Breadcrumbs/> */}
        <Outlet/>
        {!hideFooter && <Footer />}
    </div>
    {/* <div id='react'><SnackbarAlert/></div> */}
    </>
  )
}
